var render = function render(){var _vm=this,_c=_vm._self._c;return _c('selector-base',{attrs:{"label":"Merchants","hint-text":"Leave empty to allow access to all Merchants","field-name":"user[merchant_ids]","empty-text":"No Merchants in the project(s)","options-endpoint":"/find_merchants.json","visible-for-role":"merchant_support","values":_vm.merchants,"validation-error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }